/* eslint-disable @typescript-eslint/no-explicit-any */
import { MiCardList } from "@miplatform/components";
import { IBidResponse } from "@miplatform/types";
import { useTheme } from "@mui/material/styles";
import { getDaysUntilDue } from "../useBidsViewModel";

export function BidCard({ item, ...rest }: { item: IBidResponse }) {
  const theme = useTheme();

  const daysUntilDue = getDaysUntilDue(item);

  const isDateApproaching = daysUntilDue <= 2 && daysUntilDue >= 0;
  const isDatePast = daysUntilDue < 0;

  return (
    <MiCardList
      item={item}
      containerStyles={{
        backgroundColor: isDateApproaching
          ? theme.palette.warning.light
          : isDatePast
          ? theme.palette.error.light
          : "",
      }}
      {...rest}
    />
  );
}
